/*
 * 日期和时间操作集合
 *
 * */
function Timespan(delimiter = "-"){
    this.delimiter = delimiter
    this.times = []
    this.allTimes = [
        {
            name: '今天',
            date: this.getToday()
        },
        {
            name: '昨天',
            date: this.getYesterday()
        },
        {
            name: '最近7天',
            date: this.getOneWeekAgo()
        },
        {
            name: '最近30天',
            date: this.getOneMonthAgo()
        },
        {
            name: '最近90天',
            date: this.getThreeMonthAgo()
        },
    ]
    this.allTimes.forEach( time => {
        time.active = false
    })
}

Timespan.prototype.filterTimes = function(filters){
    let times
    switch(filters){
        case 'normal':
            times = this.allTimes.slice(0,4)
            break
        case 'yesterday':
            times = this.allTimes.slice(1,4)
            break
        //只有昨天
        case '-1':
            times = this.allTimes.slice(1, 2)
            break
        // 昨天和今天
        case '0, -1':
            times = this.allTimes.slice(0, 2)
            break
        //只有近7日
        case 'only7':
            times = this.allTimes.slice(2,3)
            break
        case '7a':
            times = this.allTimes.slice(2,4)
            break
        default:
            break
    }
    this.times = times
    return times
}

Timespan.prototype.setActive = function(time){
    this.times.forEach(time => time.active = false)
    time.active = true
}

Timespan.prototype.deactiveAll = function(){
    this.times.forEach(time => time.active = false)
}

Timespan.prototype.getDate = function(d){
    const year  = d.getFullYear()
    const mon   = d.getMonth() + 1
    const date  = d.getDate()
    return [year,formatTime(mon), formatTime(date)].join(this.delimiter)
}

Timespan.prototype.now = function(){
    return new Date()
}

Timespan.prototype.getDateOffset = function(offset){
    const now = this.now()
    now.setDate(now.getDate() + offset)
    return this.getDate(now)
}

Timespan.prototype.getYesterday = function(){
    return {
        start: this.getDateOffset(-1),
        end: this.getDateOffset(-1)
    } 
}

Timespan.prototype.getToday = function(){
    return {
        start: this.getDateOffset(0),
        end: this.getDateOffset(0)
    } 
}

Timespan.prototype.getOneWeekAgo = function(){
    return {
        start: this.getDateOffset(-7),
        end: this.getDateOffset(-1)
    } 
}

Timespan.prototype.getOneMonthAgo = function(){
    return {
        start: this.getDateOffset(-30),
        end: this.getDateOffset(-1)
    } 
}

Timespan.prototype.getThreeMonthAgo = function(){
    return {
        start: this.getDateOffset(-90),
        end: this.getDateOffset(-1)
    } 
}

Timespan.prototype.getTYWM = function(){
    return this.times
}

function formatTime(t){
    return t > 9 ? '' + t : '0' + t 
}

export default Timespan



// WEBPACK FOOTER //
// ./src/component/timespanHelper.js